import { connect } from 'react-redux';
import ResendActivation from './ResendActivation';
import { fetchResendActivation } from "../../../reducers/account/activation";
import { getSubmitFormSuccessStatus } from "../../../reducers/common/submitForm";
import { getTranslation } from "../../../reducers/common/localization";

const mapStateToProps = state => {
    return {
        success: getSubmitFormSuccessStatus(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSubmit: email => dispatch(fetchResendActivation(email))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResendActivation);



// WEBPACK FOOTER //
// ./src/components/accountManagement/resendActivation/ResendActivation.container.js